<template >
  <Header
    :style="{ 
    position: 'fixed', 
    width: '100%', 
    zIndex: 11, 
    paddingLeft: isCollapsed ? '96px' : '220px', 
    background: '#fff',
    boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.5)',
    lineHeight: '0'
	}"
  >
    <Row type="flex" justify="space-between">
      <Col>
        <div class="header-game-btn"> 
          <Select v-if="gameSelect.length" v-model="nowGame" style="width: auto;min-width: 120px;">
            <Option
              v-for="item in gameSelect"
              :key="item.gameid"
              :value="item.gameid"
            >{{ item.gamename }}</Option>
          </Select>
        </div>
      </Col>
      <Col :style="{width: '387px'}">
        <div class="right">
          <Dropdown class="_alignmiddle header-list-dropdown">
            <a href="javascript:void(0)" class="header-list-dropdown-text">
              <Icon type="ios-contact" />
              <span>帳戶: {{ getmember.uname }}</span>
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem @click.native="$router.push({ name: 'fixpass' })">修改密码</DropdownItem>
              <DropdownItem @click.native="logout">会员登出</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="right">
          <Button shape="circle" type="success" class="mr-2" @click="openPeriod">
            <b>快速开盘</b>
          </Button>
          <Button shape="circle" type="error" @click="closePeriod">
            <b>快速关盘</b>
          </Button>
        </div>
      </Col>
      <Col span="24">
        <site-supersision />
      </Col>
    </Row>
  </Header>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import hrom from "./hron";
import siteSupersision from "./siteSupersision";
export default {
  components: {
    hrom,
    siteSupersision
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getmember", "getAllGame", "getgameid"]),
    nowGame: {
      get() {
        return this.getgameid;
      },
      set(val) {
        return this.setGameclass(val);
      }
    },
    gameSelect () {
      if (this.getAllGame && !this.getAllGame.length) return []
      let gameObj = this.getAllGame.filter(item => [1, 14, 15, 78, 201, 210, 212, 213, 224, 225, 226, 227, 228, 229].includes(item.gameid))
      return gameObj
    }
  },
  watch: {
    getgameid(val) {
      this.$router.push({ name: this.$route.name, params: { GD: val } })
    },
    '$route'() {
      this.nowGame = Number(this.$route.params.GD)
    }
  },
  methods: {
    ...mapActions(["setGameclass"]),
    async openPeriod() {
      try {
        const res = await this.$axios.foop(this.getgameid, { loid: this.getmember.pid });
        if (res.status == 1) this.$Message.success("已开盘");
      } catch (error) {
        console.log(error);
      }
    },
    async closePeriod() {
      try {
        const res = await this.$axios.periodManagement.closePeriod(
          this.getgameid,
          {
            pid: 0,
            loid: this.getmember.pid
          }
        );
        if (res.status == 1) this.$Message.success("已关盘");
      } catch (error) {
        console.log(error);
      }
    },
    logout() {
      let logout = { loid: this.getmember.pid };
      this.$axios.logout(logout).then(data => {
        if (data.status == "1") {
          alert("成功登出");
          this.$localForage.clear();
          this.$router.push({ path: "/" });
          location.href = "http://www.baidu.com/";
        }
      });
    }
  }
};
</script>
<style lang="scss">
.ivu-layout-header {
  transition: padding .1s ease .1s;
}
.header-game-btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 5px;
  background-color: $header-game-btn-bg;
  color: #fff;
  display: inline-block;
  font-size: 12px;
}
.header-list-btn {
  line-height: 40px;
}
.header-list-dropdown {
  margin-left: 55px;
  font-size: 14px;
}
.header-list-dropdown-text {
  color: #515a6e;
  i,
  span {
    margin: 0 4px;
  }
}
</style>